var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import api from "@/api/admin";
import { useAcl } from "@/api/auth/useAcl";
import useAdminStore from "@/services/store/useAdminStore";
import useErrorHandler from "@/utilities/hooks/useErrorHandler";
import translate from "@/utilities/i18n/getTranslate";
import { k } from "@/utilities/i18n";
import { EpartnerBillingSystem } from "@/api/partners/partners.types";
export var ebankPaymentProcessors = [
    EpartnerBillingSystem.BOLETO,
    EpartnerBillingSystem.PIX
];
export var isEbankPaymentProcessor = function (processor) {
    return Boolean(processor &&
        ebankPaymentProcessors.includes(processor));
};
/**
 * PIX and Boleto payments require a Brazilian tax id (CPF/CNPJ) on the partner's
 * billing data. Saves it and refreshes the store so every consumer sees it.
 */
var useSaveTaxId = function () {
    var adminStore = useAdminStore().adminStore;
    var partnerId = useAcl().partnerId;
    var handleError = useErrorHandler();
    var _a = __read(React.useState(false), 2), isSaving = _a[0], setIsSaving = _a[1];
    var saveTaxId = function (taxId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!partnerId)
                        return [2 /*return*/, false];
                    setIsSaving(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, api.partners.updateBillingData({ partnerId: partnerId }, { tax_id: taxId.trim() })];
                case 2:
                    _b.sent();
                    _a = adminStore;
                    return [4 /*yield*/, api.partners.get.billingData({
                            partnerId: partnerId
                        })];
                case 3:
                    _a.billingData = _b.sent();
                    return [2 /*return*/, true];
                case 4:
                    error_1 = _b.sent();
                    handleError(error_1, { message: translate(k.ERR_savingTaxIdError) }, "Saving tax id failed");
                    return [2 /*return*/, false];
                case 5:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return { saveTaxId: saveTaxId, isSaving: isSaving };
};
export default useSaveTaxId;
//# sourceMappingURL=data:application/json;base64,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